<template>
  <div class="ol-map-dialog-main prodjectbox" v-if="showProjectDetail">
    <i class="el-icon-error prodjectclose" @click="closeFun"></i>

    <div class="prodjectbox-title">{{ projectDetail.name }}</div>
    <el-image
      class="projectDetail_img"
      :src="projectDetail.imageUrl"
      :preview-src-list="[projectDetail.imageUrl]"
    >
    </el-image>
    <div class="projectDetail_dec">{{ projectDetail.introdiction }}</div>
  </div>
</template>
<script>
export default {
  name: "introduction",
  data() {
    return {};
  },
  props: {
    showProjectDetail: {
      type: Boolean,
      default: false,
    },
    projectDetail: {
      type: Object,
      default: {},
    },
    closeFun: {
      type: Function,
      default: () => {},
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.ol-map-dialog-main.prodjectbox {
  position: absolute;
  right: 6%;
  height: 360px;
  padding: 20px;
  box-shadow: 0px -4px 10px 0px rgba(146, 159, 168, 0.4);
  top: 12%;
  transform: translateY(0);
  z-index: 2;
  width: 360px;
  left: inherit;
  height: 400px;
  border: 1px solid rgb(30, 124, 104);
  background: rgba(4, 54, 35, 0.8) !important;

  .projectDetail_img {
    height: 30%;
  }

  .prodjectbox-title {
    font-size: 18px;
    margin-bottom: 12px;
    color: rgba(53, 241, 193, 1);
  }

  .projectDetail_dec {
    font-size: 12px;
    max-height: 50%;
    overflow-y: auto;
  }

  .prodjectclose {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 26px;
    color: rgb(30, 102, 87);
    z-index: 3;
    cursor: pointer;
  }
}

.ol-map-dialog-main {
  .ol-map-dialog-title {
    font-size: 25px;

    margin-top: 25px;
    margin-bottom: 25px;
    color: rgba(53, 241, 193, 1);
  }

  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 600px;
  left: 50%;
  width: 520px;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  padding: 0px 30px 30px;
  border: 1px solid rgba(139, 177, 226, 0.4);
  border-radius: 4px;
  box-shadow: 0px 0px 10px 2px rgba(146, 159, 168, 0.4) inset;
  background: url("~@/assets/images/layout/tablebg.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;

  .projectDetail_img {
    text-align: center;
    width: 100%;
    height: 40%;

    img {
      width: 100%;
      height: 100%;
    }

    margin-bottom: 20px;
  }

  .projectDetail_dec {
    font-size: 16px;
    max-height: 250px;
    overflow-y: auto;
    line-height: 30px;
    color: #fff;
  }
}

.close-btn {
  position: absolute;
  top: -32px;
  right: -61px;
  font-size: 40px;
  margin: 0;
  color: #92ffd1;
  cursor: pointer;
}
</style>
